import React, { useEffect, useRef, useState } from "react";
import classes from "./ModalUsersFiltered.module.scss";
import close_button from "./../../../assets/images/close_button.svg";
import icon_copy from "./../../../assets/images/icon_copy.svg";
import img_not_found from "../../../components/FriendlyInfo/images/img_not_found.png"

interface Interface {
  open?: boolean;
  setOpen?: any;
  usersShowWhite?: any;
  indexCardWhite?: any;
  usersShowBlue?: any;
  indexCardBlue?: any;
  listUserFiltered?: any;
  cardBlueObj?: any;
  cardWhiteObj?: any;
}

const ModalUsersFiltered = ({
  open,
  setOpen,
  usersShowWhite = [],
  indexCardWhite,
  usersShowBlue = [],
  indexCardBlue,
  listUserFiltered = [],
  cardBlueObj = [],
  cardWhiteObj = [],
}: Interface) => {
  const [copyInfo, setCopyInfo] = useState(false);
  const codeXciptvRef = useRef(null);
  useEffect(() => {
    setCopyInfo(false);
  }, [open]);

  const copyToClipboard = () => {
    if (codeXciptvRef.current) {
      const range = document.createRange();
      const node = codeXciptvRef.current;
      if (node) {
        range.selectNode(node);
        const selection = window.getSelection();
        if (selection) {
          selection.removeAllRanges();
          selection.addRange(range);
          document.execCommand("copy");
          selection.removeAllRanges();
        }
      }
    }
  };

  return open && indexCardWhite === 6 ? (
    <div className={classes.ModalMainPlays}>
      <div className={classes.ModalTitle}>
        <div className={classes.ModalTitleText}>JOGADAS</div>
        <img
          className={classes.ModalTitleCloseButton}
          src={close_button}
          alt=""
          onClick={() => {
            setOpen(!open);
          }}
        />
      </div>
      <div className={classes.CardBottomPlays}>
        <div>{`N° total de jogadas: ${(listUserFiltered || []).reduce(
          (total: any, objeto: any) => {
            return total + objeto.amt_plays;
          },
          0
        )}`}</div>
        <div>{`Quantidade de usuários: ${(listUserFiltered || []).length}`}</div>
      </div>
    </div>
  ) : open && indexCardWhite === 7 ? null : open && indexCardWhite !== 6 ? (
    <div className={classes.ModalMain}>
      <div className={classes.ModalTitle}>
        <div className={classes.ModalTitleText}>{cardBlueObj[indexCardBlue]?.title.toUpperCase() ||
          cardWhiteObj[indexCardWhite]?.title.toUpperCase()}</div>
        <img
          className={classes.ModalTitleCloseButton}
          src={close_button}
          alt=""
          onClick={() => {
            setOpen(!open);
          }}
        />
      </div>
      <div className={classes.CardBottom}>
        <div className={classes.CardBottomTitle}>
          <div className={classes.CardBottomTitleLeft}>id</div>
          <div
            onClick={() => {
              copyToClipboard();
              setCopyInfo(true);
            }}
            className={classes.CardBottomTitleRight}
          >
            <img src={icon_copy} alt="" />{" "}
            <div>{copyInfo ? "copiado" : "copiar"}</div>
          </div>
        </div>

        <div ref={codeXciptvRef} className={classes.CardBottomDesc}>
          {((usersShowWhite?.[indexCardWhite]?.length > 0) || (usersShowBlue?.[indexCardBlue]?.length > 0)) ? (
            <>
              {usersShowWhite?.[indexCardWhite]?.map((user: any, index: number) => (
                <div key={`white-${index}`}>{user.registry}</div>
              ))}
              {usersShowBlue?.[indexCardBlue]?.map((user: any, index: number) => (
                <div key={`blue-${index}`}>{user.registry}</div>
              ))}
            </>
          ) : (
            <div className={classes.CardEmpty}>
              <img width={150} src={img_not_found} alt="" />
              <p>Sem usuários cadastrados no momento</p>
            </div>
          )}
        </div>
      </div>
    </div>
  ) : null;
};

export default ModalUsersFiltered;
